import Vue from 'vue'

// Lib imports
import axios from 'axios'

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.post['Content-Type'] ='application/x-www-form-urlencoded';
window.axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

window.axios.defaults.headers.post['Authorization'] = 'Bearer ' + $cookies.get('Session_Cookie');
window.axios.defaults.headers.get['Authorization'] = 'Bearer ' + $cookies.get('Session_Cookie');
window.axios.defaults.headers.put['Authorization'] = 'Bearer ' + $cookies.get('Session_Cookie');
window.axios.defaults.headers.delete['Authorization'] = 'Bearer ' + $cookies.get('Session_Cookie');

window.axios.defaults.headers.post['Accept'] = 'aplication/json';
window.axios.defaults.headers.get['Accept'] = 'aplication/json';
window.axios.defaults.headers.put['Accept'] = 'aplication/json';



Vue.prototype.$http = axios
